// src/encounter/structured-note/risk-optional-words.ts
// PROD-3404 · the optional block's words (risk-optional-block.tsx). Kept apart from the component (react-refresh).

/** The question without "present" ("Fall risk present" → "Fall risk"), and its chips: "No pain · Pain" for a one-word noun,
 *  else "No · Yes" (the catalog's rule, feat/signal `EncounterDev.tsx` `OptionalBlock`). */
export function optionalBlockWords(presentText: string | undefined): { question: string; no: string; yes: string; noSummary: string } {
  const question = (presentText ?? '').replace(/\s+present\s*\??$/i, '').trim() || 'Present';
  const single = !/\s/.test(question);
  return {
    question,
    no: single ? `No ${question.toLowerCase()}` : 'No',
    yes: single ? question : 'Yes',
    noSummary: `No ${question.toLowerCase()}`,
  };
}
